import React from 'react';
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import ExecutiveDashboard from "../../../../../components/Containers/ExecutiveDashboard";
import Select from "react-select";
import Types from "../../../../../constants/Types";
import APPCONFIG from "../../../../../constants/Config";
import {Button, ButtonGroup} from "reactstrap";
import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment-timezone";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import ClipLoader from "react-spinners/ClipLoader";

const breadcrumbStatic = [{
	name: 'Executives',
	url: '/executives',
	icon: 'dashboard'
}];

export default class ExecutiveDashboardContainer extends Framework.Components.View {
	constructor(props) {
		super(props);
		this.state.forceRefresh = Math.random();
		this.state.lastTriggered = null;
		this.state.filterDate = moment().format('YYYY-MM-DD');
		this.interval = null;
		this.state.booking_data = {
			"net_books": 0,
			"new_books": 0,
			"existing_books": 0,
			"cancels": 0,
			"tfos": 0,
			"book_percent": 0
		};
		this.state.wo_data = {
			"gross": 0,
			"fes_working": 0,
			"avg_wo": 0,
			"total_wos": 0,
			"completed_wos": 0,
			"outstanding_wos": 0
		};
		this.state.tor_data = {
			"fe_tor_count": 0,
			"fe_tor_amount": 0,
			"dispatch_tor_count": 0,
			"dispatch_tor_amount": 0,
			"next_day_fe_tors": 0,
			"next_day_dispatch_tors": 0
		};
		this.state.hiring_data = {};
		this.state.av_financials = {items: [], annual_total: 0};
		this.state.av_alert_thresholds = {bitdefender: 0, malwarebytes: 0};
		this.state.av_metrics_cached_at = null;
		this.state.loading = true;
		this.state.slowLoad = false;
		this.slowLoadTimer = null;
	}

	async componentDidMount() {
		await this.getExecutiveInfo();
		// Parameterized auto-refresh, configurable via APPCONFIG.settings.executiveDashboardRefreshMs
		this.interval = setInterval(this.getExecutiveInfo, APPCONFIG.settings.executiveDashboardRefreshMs);
	}

	componentWillUnmount() {
		clearInterval(this.interval); // Cleanup on unmount
		this.clearSlowLoadTimer();
	}

	clearSlowLoadTimer = () => {
		if (this.slowLoadTimer) {
			clearTimeout(this.slowLoadTimer);
			this.slowLoadTimer = null;
		}
	};

	getExecutiveInfo = async () => {
		this.clearSlowLoadTimer();
		this.setState({loading: true, slowLoad: false});
		this.slowLoadTimer = setTimeout(() => {
			this.setState({slowLoad: true});
		}, 3000);
		try {
			let model = new API.BuildClass(Types.Executives._name, API.RequestType.READ);
			this.read = 'GET_DASHBOARD';
			model.filter = {
				'day': this.state.filterDate,
			}
			this.data = await model.submit(null, this.read);
			this.setState({
				av_data: this.data.av_data,
				av_alert_thresholds: this.data.av_alert_thresholds,
				tor_data: this.data.tor_data,
				wo_data: this.data.wo_data,
				booking_data: this.data.booking_data,
				hiring_data: this.data.hiring_data,
				av_financials: this.data.av_financials,
				av_metrics_cached_at: this.data.av_metrics_cached_at,
				forceRefresh: Math.random(),
				loading: false,
				slowLoad: false,
			});
		} catch (error) {
			this.setState({loading: false, slowLoad: false});
		} finally {
			this.clearSlowLoadTimer();
		}
	}

	render() {
		let {history} = this.props;
		const {loading} = this.state;
		return (
			<div className="container-fluid">
				<div style={{position: 'relative'}}>
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"row rbc-toolbar"} style={{marginLeft: 15}}>
						<div>
							<IconButton onClick={async () => {
								this.setState({filterDate: moment(this.state.filterDate).subtract(1, 'day').format('YYYY-MM-DD')}, async () => {
									await this.getExecutiveInfo();
								})
							}}><LeftArrowIcon/></IconButton>
							<button className="rbc-today" type="button" onClick={async () => {
								this.setState({filterDate: moment(Date.now()).format('YYYY-MM-DD')}, async () => {
									await this.getExecutiveInfo();
								})
							}}>Today
							</button>
							<IconButton onClick={async () => {
								this.setState({filterDate: moment(this.state.filterDate).add(1, 'day').format('YYYY-MM-DD')}, async () => {
									await this.getExecutiveInfo();
								})
							}}><RightArrowIcon/></IconButton>
						</div>
						<div className={"rbc-toolbar-label"}>
							<label>
								{moment(this.state.filterDate).format('dddd MMM D')}
							</label>
						</div>
					</div>
					<div className={'col d-flex justify-content-end align-items-start'}>
						<div className={'rbc-toolbar'}>
							<button className="rbc-today" type="button" onClick={async () => {
								await this.getExecutiveInfo();
							}}>Refresh
							</button>
						</div>
					</div>
				</div>

				<ExecutiveDashboard history={history} forceRefresh={this.state.forceRefresh} filterDate={this.state.filterDate} av_data={this.state.av_data} av_alert_thresholds={this.state.av_alert_thresholds} booking_data={this.state.booking_data} wo_data={this.state.wo_data} tor_data={this.state.tor_data} hiring_data={this.state.hiring_data} av_financials={this.state.av_financials} av_metrics_cached_at={this.state.av_metrics_cached_at}/>

				<div
					style={{
						position: 'absolute',
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
						zIndex: loading ? 10000 : -1,
						opacity: loading ? 1 : 0,
						pointerEvents: loading ? 'all' : 'none',
						background: 'rgba(0,0,0,0.2)',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						transition: 'opacity 0.3s ease',
					}}
				>
					<ClipLoader color="#4A4A4A" loading={loading}/>
					{this.state.slowLoad && (
						<div
							style={{
								marginTop: 24,
								maxWidth: 420,
								padding: '16px 20px',
								background: '#fff',
								borderRadius: 8,
								boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
								textAlign: 'center',
								color: '#333',
								fontSize: 14,
								lineHeight: 1.5,
							}}
						>
							<div style={{fontWeight: 600, marginBottom: 8}}>
								Syncing Anti-Virus subscription data from Stripe…
							</div>
							<div>
								This happens once per day and can take up to a minute. Subsequent loads today will be instant.
							</div>
						</div>
					)}
				</div>
				</div>
			</div>
		)
	}
}